import { render, staticRenderFns } from "./ItemWriteDetectionRequestLayout.vue?vue&type=template&id=ceb9b072&scoped=true&"
import script from "./ItemWriteDetectionRequestLayout.vue?vue&type=script&lang=js&"
export * from "./ItemWriteDetectionRequestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb9b072",
  null
  
)

export default component.exports